export default function safeGetter<T, K extends keyof T>(
  obj: Nullable<T>,
  prop: K,
  def: T[K]
): T[K] {
  return obj ? obj[prop] : def;
}
